import { Routes, RouterModule } from "@angular/router";
import { ReportInboxComponent } from "./report-inbox/report-inbox.component";
import { ScheduledReportsComponent } from "./scheduled-reports/scheduled-reports.component";
import { ReportInboxDetailComponent } from "./report-inbox-detail/report-inbox-detail.component";

export const ReportInboxRoutes: Routes = [
	{
		path: "inbox",
		data: { title: "Inbox" },
		component: ReportInboxComponent,
	},
	{
		path: "inbox/:id",
		data: { title: "Inbox Report" },
		component: ReportInboxDetailComponent,
	},
	{
		path: "scheduledreports",
		data: { title: "Scheduled Reports" },
		component: ScheduledReportsComponent,
	},
];
